import {GET, POST, baseURL, headers} from '../utils/constants'
import fpti from '../instrumentation'
import {fptiConstants, fptiEvents} from "../utils/fptiConstants";

const get = async (url) => {
  const start = window.PAYPAL.analytics.Analytics.prototype.getTimeNow()
  const res = await fetch(`${baseURL}${url}`, {
    method: GET,
    headers,
  })
  const end = window.PAYPAL.analytics.Analytics.prototype.getTimeNow()
  fpti.logAPIPerformance(start, end, url.split('?', 1)[0], fptiEvents.API_PERFORMANCE, fptiConstants.SPACE_KEY)
  const response = await res.json()
  if (!res.ok) {
    return Promise.reject(response)
  }
  return { data: response }
}

const post = async (url, entry) => {
  const start = window.PAYPAL.analytics.Analytics.prototype.getTimeNow()
  const res = await fetch(`${baseURL}${url}`, {
    method: POST,
    headers,
    body: JSON.stringify(entry),
  })
  const end = window.PAYPAL.analytics.Analytics.prototype.getTimeNow()
  fpti.logAPIPerformance(start, end, url.split('?', 1)[0], fptiEvents.API_PERFORMANCE, fptiConstants.SPACE_KEY)
  const response = await res.json()
  if (!res.ok) {
    return Promise.reject(response)
  }
  return { data: response }
}

export default {
  get,
  post,
}
